module.exports = {

  researchRequests: ($stateParams, Api) ->
    return Api.ResearchRequest.query({project: $stateParams.projectId}).$promise

  manualWorkflowStepIterations: ($stateParams, Api) ->
    if $stateParams.projectId
      return Api.ManualWorkflowStepIteration.query({project: $stateParams.projectId}).$promise
    return []

  loadTemplates: ( $templateCache ) ->
    $templateCache.put('project-findings-toc', require('./project-findings-toc.html'))

}
